import { RESPONSE, VAST } from '../constants';

const normalizeId = (id) => (id === null || typeof id === 'undefined' ? null : String(id));

const normalizeIds = (ids) => ids.map(normalizeId).filter(Boolean);

const getBidIdCandidates = (bid) => normalizeIds([bid?.id, bid?.impid, bid?.ext?.id, bid?.ext?.bidId]);

const getCridCandidates = (bid) => normalizeIds([bid?.crid, bid?.cridId, bid?.cridid, bid?.ext?.crid]);

const isMatchingBidId = (bid, demandBidId) =>
  Boolean(demandBidId && getBidIdCandidates(bid).includes(normalizeId(demandBidId)));

const isMatchingCrid = (bid, cridId) => Boolean(cridId && getCridCandidates(bid).includes(normalizeId(cridId)));

export const getBidResponseMultiRequest = (data, demandBidId, cridId) => {
  const normalizedDemandBidId = normalizeId(demandBidId);
  const normalizedCridId = normalizeId(cridId);
  let bidIdMatch = null;
  let cridMatch = null;

  for (const { record } of data || []) {
    for (const { bid: bids = [] } of record?.rawData?.seatbid || []) {
      for (const bid of bids) {
        const matchesBidId = normalizedDemandBidId && isMatchingBidId(bid, normalizedDemandBidId);
        const matchesCrid = normalizedCridId && isMatchingCrid(bid, normalizedCridId);

        if (matchesBidId && (!normalizedCridId || matchesCrid)) {
          return bid;
        }

        if (matchesBidId && !bidIdMatch) {
          bidIdMatch = bid;
        }

        if (matchesCrid && !cridMatch) {
          cridMatch = bid;
        }
      }
    }
  }

  return bidIdMatch || cridMatch || null;
};

const getVastIdCandidates = (vastRawData) =>
  normalizeIds([
    vastRawData?.id,
    vastRawData?.ad?.id,
    vastRawData?.ad?.crid,
    vastRawData?.ad?.cridId,
    vastRawData?.ad?.cridid,
    vastRawData?.ad?.creativeId,
    vastRawData?.ad?.['creative-id'],
    vastRawData?.ad?.creative?.id,
  ]);

export const getVastRawDataMultiRequest = (data, { bidId, cridId }) => {
  const normalizedBidId = normalizeId(bidId);
  const normalizedCridId = normalizeId(cridId);

  if (!normalizedBidId && !normalizedCridId) {
    return null;
  }

  return (
    data?.find(({ record }) => {
      const vastIds = getVastIdCandidates(record?.rawData);
      return (
        (normalizedBidId && vastIds.includes(normalizedBidId)) ||
        (normalizedCridId && vastIds.includes(normalizedCridId))
      );
    })?.record?.rawData || null
  );
};

export const buildVastAdFields = (vastRawData) => ({
  adId: vastRawData?.ad?.id,
  adSystem: vastRawData?.ad?.['ad-system'],
  adTitle: vastRawData?.ad?.name,
});

export const createMultiRequestBidDetails =
  (integratorKey, { includeCrid = true } = {}) =>
  ({ currentBid, integratorsData }) => {
    const { demandBidId, cridId } = currentBid;
    const vastRawData = getVastRawDataMultiRequest(integratorsData?.[integratorKey]?.[VAST], currentBid);

    return {
      bidWithVastData: {
        ...currentBid,
        ...buildVastAdFields(vastRawData),
      },
      bidResponse: getBidResponseMultiRequest(
        integratorsData?.[integratorKey]?.[RESPONSE],
        demandBidId,
        includeCrid ? cridId : undefined
      ),
      adResponse: vastRawData,
      isAdResponseJson: true,
    };
  };
